export function mergeSettings(baseSettings, additionalSettings) {
    if (!additionalSettings)
        return {
            settings: baseSettings,
            diff: {},
        };

    const settings = {
        ...baseSettings,
        ...additionalSettings,
    };

    const diff = {};

    Object.keys(additionalSettings).forEach((key) => {
        diff[key] = baseSettings[key];
    });

    return { settings, diff };
}
